import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Grid, Linha } from '../../styles/base';
import imagemNaoDisponivel from '../../assets/images/imagemindisponivel.png';
import { ListaNoticiaBox, BoxImagem, InfoContainer } from './ListaAgendaEstilo';

function LimpandoHTMLdaDescricao(html) {
  const myRef = useRef();

  useEffect(() => {
    myRef.current.innerHTML = html;
  });

  return (
    <span ref={myRef} />
  );
}

const ListaAgenda = ({
  capaDestaque, titulo, secretaria, descricao,
}) => (
  <ListaNoticiaBox
    className="teste"
  >
    {(((capaDestaque !== '') && (capaDestaque !== null))
      ? (
        <BoxImagem style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #0000000a',
        }}
        >
          <img
            style={{
              objectFit: 'cover', objectPosition: 'center', maxWidth: '100%', width: '100%', height: 215,
            }}
            src={capaDestaque}
            alt={titulo}
          />
        </BoxImagem>
      )
      : (
        <BoxImagem>
          <img
            style={{
              objectFit: 'cover', objectPosition: 'center', maxWidth: '100%', height: 215,
            }}
            src={imagemNaoDisponivel}
            alt={titulo}
          />
        </BoxImagem>
      ))}
    <InfoContainer style={{ padding: 10 }}>
      <p style={{
        fontSize: 15, marginTop: 5, maxWidth: '100%', fontWeight: 'bolder',
      }}
      >
        {titulo}
      </p>
      <p style={{ fontSize: 12 }}>
        {secretaria && `Secretaria: ${secretaria}`}
      </p>
      <p>{LimpandoHTMLdaDescricao(descricao)}</p>
    </InfoContainer>
  </ListaNoticiaBox>
);

ListaAgenda.propTypes = {
  capaDestaque: PropTypes.string,
  titulo: PropTypes.string,
  secretaria: PropTypes.string,
  descricao: PropTypes.string,
};

ListaAgenda.defaultProps = {
  capaDestaque: '',
  titulo: '',
  secretaria: '',
  descricao: '',
};

export default ListaAgenda;
